import { put, select, takeLatest, all } from 'redux-saga/effects';
import { notify } from '@mrlannigan/reapop';
import { sagaError } from 'helpers/handleGenericSagaError';
import apiAuthCall from 'helpers/apiAuthCall';

import { actions, crossChannelFetched } from './duck';
import { crossChannelEndpoint } from './selectors';

export function* fetchCrossChannel(api, action) {
    try {
        const result = yield apiAuthCall(
            action.getState(),
            [api, api.request],
            {
                method: 'get',
                url: yield select(crossChannelEndpoint, action.payload)
            }
        );

        yield put(crossChannelFetched(result.data));
    } catch (err) {
        yield put(notify({
            id: action.payload.transactionId,
            ...sagaError(err)
        }));
    }
}

export default function* crossChannelSagas({ api }) {
    yield all([
        takeLatest(actions.FETCH, fetchCrossChannel, api)
    ]);
}



// WEBPACK FOOTER //
// ./src/services/crossChannel/saga.js